import { useEffect, useRef } from 'react';

const useInterval = (callback, delay) => {
  const intervalRef = useRef(null);
  const savedCallback = useRef(callback);
  
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => savedCallback.current();

    if (typeof delay === 'number') {
      intervalRef.current = setInterval(tick, delay);

      return () => {
        clearInterval(intervalRef.current);
      };
    }
  }, [delay]);

  return intervalRef;
}
export default useInterval;
